import { render, staticRenderFns } from "./CForm.vue?vue&type=template&id=decdd4d4&"
import script from "./CForm.vue?vue&type=script&lang=ts&"
export * from "./CForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports